
<!--
 * @Description:添加教学设计
 * @Author: 王赵坤
 * @Date: 2022-10-28 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2024-10-09 10:31:31
-->
<template>
  <div>
    <el-dialog class="w850 hp80" :model-value="openJiaoXueSheJi" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加教学设计</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openJiaoXueSheJi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期">
              <span>{{ruleForm.xqmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程">
              {{ruleForm.kcmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次">
              <span>第{{ruleForm.zc}}周</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="班级/节次">
              <span>{{ruleForm.bjmc}}/星期{{ruleForm.xq}}第{{ruleForm.jc}}节<br></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元">
              <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容">
              <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-for="(item, index) in ruleForm.jxsjmb" :key="index">
            <el-form-item :label="item.mbzdmc" :prop="'jxsjmb.' + index + '.nr'" :rules="item.sfbt ? [{required: true,message: '必填项',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-input v-if="item.zdlx===1" v-model="item.nr" type="textarea" :rows="1" />
              <div v-if="item.zdlx===2">
                <ueditor v-model:value="item.nr" :row="{height:350}" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
          <el-button type="primary" @click="submit(0)">保存 </el-button>
          <el-button type="primary" @click="submitTj(1)">保存并提交</el-button>
          <el-button @click="closeWindow('openJiaoXueSheJi', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import {
  closeWindow,
  loadSelect,
  loadData,
  actionPost
} from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({
  openJiaoXueSheJi: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openJiaoXueSheJi', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({ jxsjbjcks: [], jxsjmb: [] })
const row = ref()
// 获取教学设计模板
const getjxsjmblist = () => {
  const o = { url: '/api/v2/jiaowu/jiaoxueshejimuban/list', data: {} }
  actionPost(o).then((res) => {
    ruleForm.value.jxsjmb = res.data.map(item => { item.zdlx = item.zdlx ? item.zdlx.value : ''; return item })
  })
}

// 查询教学单元
const jxdyData = ref([])
const keChengChange = (val) => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: val, order: 'sx', sort: 'asc' }
  })
}
// 查询教学内容
const jxnrData = ref([])
const danDuanChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}

const openAddJiaoXueDanYuan = ref(false) // 添加教学单元
const openAddJiaoXueNeiRong = ref(false) // 添加教学内容
watch(
  () => props.openJiaoXueSheJi,
  () => {
    if (props.openJiaoXueSheJi) {
      row.value = props.row
      loadData({
        url: `/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian/${props.row.id}`,
        ruleForm,
        loadSuccess: function (res) {
          keChengChange(res.data.kcid)
          getjxsjmblist()
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 保存并提交
const submitTj = async (val) => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()

  const data = {
    xqid: ruleForm.value.xqid,
    jxsjbjcks: [],
    jxsjnrs: ruleForm.value.jxsjmb,
    zc: ruleForm.value.zc,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    zt: val
  }
  const obj = {
    xlbjkbid: ruleForm.value.xlbjkbid,
    bjid: ruleForm.value.bjid,
    kcid: ruleForm.value.kcid,
    kbid: ruleForm.value.id,
    xq: ruleForm.value.xq,
    jc: ruleForm.value.jc
  }
  data.jxsjbjcks.push(obj)
  const o = { url: '/api/v2/jiaowu/jiaowujiaoxuesheji', data: data }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      closeWindow('openJiaoXueSheJi', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 保存
const submit = async (val) => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()

  const data = {
    xqid: ruleForm.value.xqid,
    jxsjbjcks: [],
    jxsjnrs: ruleForm.value.jxsjmb,
    zc: ruleForm.value.zc,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    zt: val
  }
  const obj = {
    xlbjkbid: ruleForm.value.xlbjkbid,
    bjid: ruleForm.value.bjid,
    kcid: ruleForm.value.kcid,
    kbid: ruleForm.value.id,
    xq: ruleForm.value.xq,
    jc: ruleForm.value.jc
  }
  data.jxsjbjcks.push(obj)

  const o = { url: '/api/v2/jiaowu/jiaowujiaoxuesheji', data: data }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      closeWindow('openJiaoXueSheJi', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}

</script>
<style lang="less" scoped>
.banjibox {
  width: 300px;
  display: flex;
  flex-direction: column;
}
.fwb {
  width: 400px;
}
</style>
